<template>
  <d2-container>
    <el-form :inline="true" size="mini" style="display: flex; flex-wrap: wrap; align-items: center;">
      <el-form-item label="学员姓名/手机号">
        <el-input v-model="query.keyword" clearable style="width:220px" />
      </el-form-item>
      <el-form-item style="margin-left: auto;">
        <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="rows" border v-loading="loading" highlight-current-row @current-change="selectStudent">
      <el-table-column prop="memberName" label="学员姓名" width="130" />
      <el-table-column prop="mobile" label="手机号" width="140" />
      <el-table-column prop="evaluationCount" label="评价次数" width="100" />
      <el-table-column prop="lastEvaluateTime" label="最近评价时间" width="170" />
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" @click="selectStudent(scope.row)">查看档案</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :current-page="query.page" :page-size="query.limit" :total="total"
      layout="total, prev, pager, next" @current-change="changePage" style="margin-top:12px" />

    <el-dialog :title="current ? current.memberName + ' 的培训档案' : '培训档案'" :visible.sync="drawerVisible" width="660px" append-to-body>
      <div v-if="trendLoading" style="text-align:center;padding:40px">加载中...</div>
      <div v-else-if="!trend.length" style="text-align:center;padding:40px;color:#909399">暂无评价记录</div>
      <el-timeline v-else>
        <el-timeline-item v-for="item in trend" :key="item.evaluateTime" :timestamp="formatTime(item.evaluateTime)" placement="top">
          <el-card shadow="never">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px">
              <strong>{{ item.trainName }} · {{ item.batchName }}</strong>
              <el-tag :type="item.result === 1 ? 'success' : 'warning'" size="mini">
                {{ item.result === 1 ? '通过' : '未通过' }}
              </el-tag>
            </div>
            <div style="color:#666;font-size:13px">
              <span>{{ item.preRating }} → {{ item.postRating }}</span>
              <span style="margin-left:16px">教练：{{ item.coachName || '-' }}</span>
              <span style="margin-left:16px">达标 {{ item.passedCount || 0 }} 项 / 待提升 {{ item.improveCount || 0 }} 项</span>
            </div>
          </el-card>
        </el-timeline-item>
      </el-timeline>
      <span slot="footer">
        <el-button @click="drawerVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </d2-container>
</template>

<script>
import { getStudentPage, getStudentTrend } from '@/api/pages/train/archive'

export default {
  data () {
    return {
      loading: false, trendLoading: false,
      rows: [], total: 0, trend: [],
      query: { page: 1, limit: 10, keyword: '' },
      drawerVisible: false, current: null
    }
  },
  created () { this.load() },
  methods: {
    load () {
      this.loading = true
      getStudentPage(this.query).then(data => {
        this.rows = data.page.records || []
        this.total = data.page.total || 0
      }).finally(() => { this.loading = false })
    },
    changePage (page) { this.query.page = page; this.load() },
    selectStudent (row) {
      if (!row) return
      this.current = row
      this.drawerVisible = true
      this.trend = []
      this.trendLoading = true
      getStudentTrend(row.memberId).then(data => {
        this.trend = data.data || []
      }).finally(() => { this.trendLoading = false })
    },
    formatTime (val) { return val ? String(val).replace('T', ' ').substring(0, 16) : '-' }
  }
}
</script>
